export const DialogConstants = {
  OK_BUTTON: 0,
  CANCEL_BUTTON: 1
};
